import { Box, Dialog, Typography } from '@mui/material'
import { FileUploader } from 'react-drag-drop-files'
import { useEffect, useState } from 'react'
import client from 'client'
import { v4 as uuid } from 'uuid'
import store from 'app/store'
import { showMessage } from 'app/store/fuse/messageSlice'
import { useDispatch } from 'react-redux'
import { postImage,postImages3,postProfileImage } from 'app/main/Register_v2/CompanyRegisterForms/CompanyRegisterFunctions';
import { getDataFromS3 } from "app/main/CompanyList/companyFunctions";
import {constants} from '../../../constants'
import FuseLoading from '@fuse/core/FuseLoading'

const TicketScaleImageUploader = ({open,setOpen,user,handleAddEditScaleImage,type=null, fileTypes = ['JPEG', 'PNG', 'JPG']}) => {
  // const fileTypes = ['JPEG', 'PNG', 'JPG']
  const GET_PRE_SIGNED_URL = '/aws/pre-signed-url'
  const state = store.getState()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const [preview, setPreview] =useState(null)
  const [pdfLoading, setpdfLoading] = useState(false)
  const _showMessage = (msg) => {
    dispatch(
      showMessage({
        message: (<>
          <Typography>{msg}</Typography>
        </>),//text or html
        autoHideDuration: 6000,//ms

        anchorOrigin: {
          vertical: 'top',//top bottom
          horizontal: 'right'//left center right
        },
        variant: "error" //success error info warning null
      }))
  }

  const getS3Location = async (key) => {
    if (key != null && key != "") {
      let data = {
        key: key,
      };
      return await getDataFromS3(data);
    }
  }

  // const onChange = async (file) => {
  //   console.log('FILE: ',file.type)
  //   setLoading(true)

  //   const user_id = user.user_id
  //   const reader = new FileReader();
  //   reader.onload = async () => {
  //     const res = await postProfileImage({
  //         baseString: `${btoa(reader.result)}`,
  //         company_id: user_id,
  //         fileType: type ? type : "tickets",
  //         fileName: file.name.replace(/ /g, ""),
  //         ContentType: file.type
  //     })
  //     if (res.status) {
  //       console.log('KEY HERE: ',res.data.key)
  //       handleAddEditScaleImage(res.data.key)
       
  //       /* const data = {type: type ? type : null ,arrData: [{key: res.data.key}]}
  //       const response = await postImages3(data) 
  //       console.log(response.data.fileLocation[0]) 
  //       setKey(response.data.fileLocation[0]) */
  //     }
  //     setLoading(false)

  //     if (!loading) setOpen(false)
  //   }

  //   reader.readAsBinaryString(file)
  // }

  const onChange = async (file) => {
    setLoading(true)
    const user_id = state?.loadz_auth?.AuthReducer?.user?.user_id
    try {
      let url = URL.createObjectURL(file)
      setPreview(url)

      const newKey = uuid()
      
      const params = { key: newKey, bucketType: type ? type : 'tickets', user_id, contentType: file?.type }
      
      if (file?.type?.includes('pdf')) {
        params['key'] = `${newKey}.pdf`
        params['Metadata'] = {'Content-Type': 'application/pdf', 'Content-Disposition': 'inline'};    

          const result = await client.post(GET_PRE_SIGNED_URL, params)
          if (result?.data?.key) {
            console.log(result?.data?.url)
            const uploadResult = await client.put(result.data.url, file)
            console.log(uploadResult.data)
            if (uploadResult?.status == 200) {

              //call pdf conversion 
              setpdfLoading(true)
              const pdfConversion = await client.post('/aws/convert-pdf', { file_key: result.data.key })
              setpdfLoading(false)

              //console.log('pdfConversion.data', pdfConversion.data)

              handleAddEditScaleImage(pdfConversion.data.uploaded_files)
          }
        }
      }
      else
      {
        const getType = params.contentType.split('/')[1];
        params['key'] = `${newKey}.${getType}`;
        const result = await client.post(GET_PRE_SIGNED_URL, params)
        if (result?.data?.key) {
          console.log(result?.data?.url)
          const uploadResult = await client.put(result.data.url, file)
          console.log(uploadResult.data)
          if (uploadResult?.status == 200) {
            handleAddEditScaleImage(result.data.key)
          }
        }
      
     
        
      }

      setLoading(false)

      if (!loading) setOpen(false)
    } catch (error) {
      setLoading(false)
      setOpen(false)
      _showMessage("Something Went wrong! Please try again")
      console.log('error', error)
    }
  } 

  return (
    <Dialog
    open={open}
    onClose={() => {
      if (!loading) {
        setOpen(false)
      }
    }}
  >
    {
      pdfLoading ?
    
      <div>
        <FuseLoading />
      </div>
      :
      <FileUploader
        children={
          <div className="flex flex-col p-8">
            <Box
              sx={{
                border: '5px dashed lightblue',
                borderRadius: 5,
                padding:2,
                width:'500px'
              }}
            >
              <div className="flex flex-col gap-y-16 justify-center align-center items-center pb-32">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="172"
                  height="200"
                  viewBox="0 0 172 149"
                  fill="none"
                >
                  <g clip-path="url(#clip0_141_2095)">
                    <path
                      d="M87.7472 54.6136C87.5441 54.3419 87.2804 54.1213 86.9771 53.9693C86.6738 53.8173 86.3392 53.7382 86 53.7382C85.6607 53.7382 85.3261 53.8173 85.0228 53.9693C84.7195 54.1213 84.4559 54.3419 84.2528 54.6136L56.3712 91.7765C56.1269 92.1003 55.9778 92.4858 55.9406 92.8897C55.9034 93.2936 55.9796 93.6998 56.1607 94.0628C56.3418 94.4257 56.6206 94.731 56.9657 94.9442C57.3109 95.1575 57.7086 95.2702 58.1143 95.2699H73.0645C73.6437 95.2699 74.1992 95.4993 74.6095 95.908C75.0198 96.3166 75.2514 96.8712 75.2535 97.4502V146.82C75.2525 147.107 75.3081 147.391 75.4172 147.657C75.5263 147.922 75.6868 148.163 75.8894 148.367C76.0921 148.57 76.3328 148.731 76.598 148.841C76.8631 148.951 77.1474 149.008 77.4345 149.008H94.5655C94.8526 149.008 95.1369 148.951 95.402 148.841C95.6671 148.731 95.9079 148.57 96.1105 148.367C96.3132 148.163 96.4736 147.922 96.5828 147.657C96.6919 147.391 96.7475 147.107 96.7464 146.82V97.4502C96.7486 96.8712 96.9802 96.3166 97.3904 95.908C97.8007 95.4993 98.3563 95.2699 98.9355 95.2699H113.886C114.291 95.2702 114.689 95.1575 115.034 94.9442C115.379 94.731 115.658 94.4257 115.839 94.0628C116.02 93.6998 116.097 93.2936 116.059 92.8897C116.022 92.4858 115.873 92.1003 115.629 91.7765L87.7472 54.6136Z"
                      fill="#BDBBBB"
                    />
                    <path
                      d="M154.188 51.412C153.089 50.6284 152.157 49.6333 151.447 48.4851C150.737 47.3369 150.263 46.0586 150.053 44.7251C148.278 32.8346 138.703 0 99.6814 0C79.0884 0 65.403 16.9482 62.5249 20.8388C62.1382 21.3625 61.6008 21.7556 60.9845 21.9654C60.4635 22.1457 59.904 22.1849 59.363 22.0789C54.612 21.1468 29.7545 13.3819 24.2009 43.2662C23.5359 46.5425 21.6452 49.4415 18.9148 51.3715C8.07509 59.2255 -0.00805664 71.8374 -0.00805664 85.9487C0.025205 96.2777 3.76391 106.252 10.5287 114.059C17.2934 121.866 26.6353 126.988 36.8566 128.494C38.2661 128.709 39.7033 128.355 40.852 127.511C42.0007 126.666 42.7668 125.4 42.9818 123.991C43.1968 122.582 42.8431 121.145 41.9985 119.997C41.1539 118.848 39.8876 118.082 38.4781 117.867C31.8555 116.94 25.6886 113.965 20.8401 109.361C15.9916 104.756 12.704 98.7518 11.4372 92.1873C10.1704 85.6227 10.9877 78.8265 13.7749 72.7493C16.5621 66.672 21.1797 61.6177 26.9817 58.2934C28.6711 57.3171 30.1297 55.9875 31.2575 54.3956C32.3853 52.8036 33.1558 50.9868 33.5163 49.0696C38.1538 23.3757 56.5416 33.5236 61.5276 36.8143C61.9113 37.0649 62.3422 37.2345 62.7937 37.3127C63.2453 37.3909 63.7081 37.376 64.1537 37.269C64.5994 37.162 65.0184 36.9651 65.3852 36.6904C65.752 36.4157 66.0588 36.069 66.2868 35.6715L69.6513 29.8032C76.5022 17.9046 88.6877 9.53995 102.122 10.7882C135.411 13.779 139.724 38.3462 139.935 49.5964C139.96 51.3522 140.437 53.0721 141.32 54.5898C142.203 56.1076 143.463 57.372 144.978 58.261V58.261C150.809 61.5727 155.454 66.6282 158.262 72.7166C161.069 78.8049 161.897 85.6199 160.629 92.2032C159.361 98.7864 156.061 104.807 151.193 109.418C146.325 114.028 140.133 116.998 133.49 117.908C132.08 118.123 130.814 118.889 129.969 120.037C129.125 121.186 128.771 122.622 128.986 124.032C129.201 125.441 129.967 126.707 131.116 127.551C132.264 128.395 133.702 128.749 135.111 128.534C143.577 127.349 151.494 123.657 157.842 117.933C164.19 112.21 168.678 104.717 170.728 96.4198C172.778 88.1231 172.295 79.4027 169.343 71.3824C166.391 63.3621 161.104 56.4094 154.164 51.4201L154.188 51.412Z"
                      fill="#BDBBBB"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_141_2095">
                      <rect
                        width="172"
                        height="149"
                        fill="white"
                      />
                    </clipPath>
                  </defs>
                </svg>
                &nbsp;
                <Typography className="text-18 font-bold">Drag and drop files here</Typography>
                <Typography className="text-14" color={'gray'}>OR</Typography>
                <div className='flex w-3/5 justify-center align-center items-center'
                style={{border: '1px solid gray',padding:6, cursor:'pointer' }}
                >
                <Typography className="text-16 font-bold" color={'blue'}>Click here to upload</Typography>
                </div>
                <div className="flex flex-col justify-center align-center items-center" style={{color:'gray'}}>
                  <Typography className="text-14">These are the allowed image formats:</Typography>
                  <div>{fileTypes.join(", ")}</div>
                </div>
              </div>
            </Box>
          </div>
        }
        handleChange={onChange}
        name="file"
        types={fileTypes}
      />
    }
  </Dialog>
  )
}

export default TicketScaleImageUploader;